import Axios from '../request';

// 取消订单
import { UIC_HOST } from '@/config/host';

// 订单详情
export function fetchOrderDetails(data = {}) {
  return Axios.post(
    UIC_HOST,
    {
      name: 'user.order.detail',
      data: JSON.stringify(data),
    },
    {
      custom: {
        isResEncrypt: true,
      },
    },
  );
}

// 获取司机信息
export function fetchCarInfo(data = {}) {
  return Axios.post(
    UIC_HOST,
    {
      name: 'user.order.driver.car.info.v2',
      data: JSON.stringify(data),
    },
    {
      custom: {
        isResEncrypt: true,
      },
    },
  );
}

/**
 *
 * 拉黑司机
 * @param {object} - data
 * @param {string} - data.driverFid
 * @param {string} - data.orderId
 * @param {number} - data.scene 场景ID，1：乘客取消订单后， 2：乘客评价后
 */
export function fetchBlockDriver(data = {}) {
  return Axios.post(UIC_HOST, {
    name: 'blacklist.add',
    data: JSON.stringify(data),
  });
}
